<template>
  <el-form ref="form" :model="form" :rules="rules">
    <el-form-item label="企业名称" prop="company_name">
      <el-input
        style="width: 900px"
        placeholder="请输入公司名称"
        v-model="form.company_name"
      ></el-input>
    </el-form-item>
    <div class="form-row">
      <el-form-item label="姓名" prop="name">
        <el-input
          style="width: 438px"
          placeholder="请输入姓名"
          v-model="form.name"
        ></el-input>
      </el-form-item>
      <el-form-item label="职位" prop="job">
        <el-input
          style="width: 438px"
          placeholder="请输入职位"
          v-model="form.job"
        ></el-input>
      </el-form-item>
    </div>
    <div class="form-row">
      <el-form-item label="联系电话" prop="mobile">
        <el-input
          style="width: 438px"
          maxlength="11"
          placeholder="请输入手机号"
          v-model="form.mobile"
        ></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱" prop="email">
        <el-input
          style="width: 438px"
          placeholder="请输入电子邮箱"
          v-model="form.email"
        ></el-input>
      </el-form-item>
    </div>
    <el-form-item label="你最新希望爱设计为你解决哪些问题？">
      <el-input
        style="width: 900px"
        placeholder="如何让设计师从重复修改中解脱出来？"
        v-model="form.message"
      ></el-input>
    </el-form-item>
    <el-button type="primary" style="width: 900px" @click="onSubmit('form')"
      >提交</el-button
    >
  </el-form>
</template>

<script>
import { Landing } from "@/config/axios/landing.js";
import statistics from "@/utils/statistic/statistics";
import tokenFunc from "@/config/static/token";
export default {
  name: "question",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        const reg = /^1[1-9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      form: {
        company_name: "",
        name: "",
        job: "",
        mobile: "",
        email: "",
        message: "",
        source: 2,
      },
      rules: {
        company_name: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        job: [
          {
            required: true,
            message: "请输入职位",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    onSubmit(form) {
      if (tokenFunc.getToken()) {
        this.form.user_id = this.loginInfo.id
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          Landing.getApply(this.form)
            .then((res) => {
              this.form = {};
              this.form.source = 2;
              this.$message(res.message);

              // 埋点上报
              statistics.__sendEvent({
                statsMark: "企业落地页-表单提交按钮点击pv",
                projectPage: this.$route.meta.projectPage,
                projectArea: "63",
                eventArea: "63",
                eventType: "3",
                eventId: "259",
                eventName: "company_vip_page_submit_pv",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  margin: 0 auto;
}

::v-deep( .el-form-item) {
  margin-right: 24px;
  margin-bottom: 20px;
}

::v-deep( .el-form-item__label) {
  text-align: left;
  float: none;
  word-break: break-word;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #333333;
  font-weight: 600;
}
.form-row {
  display: flex;
}
</style>
